import React from 'react';
import { Editor } from 'components';
import Container from "./Container";
import Page from './Page';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  leftColumn: {
    flexGrow: 1,
    paddingRight: '16px',
    boxSizing: 'border-box',
  },
  rightColumn: {
    width: '50%',
    maxWidth: '143mm',
    boxSizing: 'border-box',
  },
  descriptionTitle: {
    fontWeight: 'bold',
  },
  descriptionContainer: {
    display: 'flex',
    fontSize: '13px',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '16px',
  },
  editorContainer: {
    marginBottom: '20px',
  },
};

class Template extends React.Component {
  constructor(props) {
    super(props);
    this.tmplRef = React.createRef();
  }

  render() {
    const { changeContent, product, content, removableArea: RemovableArea } = this.props;

    const featuresContentList = product?.features?.features || [];
    const featuresContent = !!featuresContentList.length
      ? `<p style="font-weight: bold;">FEATURES</p><ul>${featuresContentList.map(
          (item) => `<li>${item}</li>`
        )}</ul>`
      : '';

    return (
      <Container containerRef={this.props.containerRef}>
        <Page
          removableArea={RemovableArea}
          product={product}
          pageRef={this.tmplRef}
        >
          <div style={styles.container}>
            <div style={styles.leftColumn}>
              <Editor
                style={styles.editorContainer}
                content={content?.features || featuresContent}
                setContent={(value) => changeContent('features', value)}
              />
              <Editor
                content={content?.section2}
                setContent={(value) => changeContent('section2', value)}
              />
            </div>
            {product.imageUrl && (
              <div style={styles.rightColumn}>
                <RemovableArea data-removable id="image" style={styles.image}>
                  <img src={product.imageUrl} />
                </RemovableArea>
              </div>
            )}
          </div>
          <RemovableArea
            style={styles.descriptionContainer}
            data-removable
            id="description"
          >
            <div>
              <p>
                <span style={styles.descriptionTitle}>DESCRIPTION</span>
              </p>
            </div>
            <div>{product.description}</div>
          </RemovableArea>
          <Editor
            content={content?.section5}
            setContent={(value) => changeContent('section5', value)}
            style={styles.editorContainer}
          />
          <Editor
            content={content?.section6}
            setContent={(value) => changeContent('section6', value)}
            style={styles.editorContainer}
          />
          <Editor
            content={content?.section7}
            setContent={(value) => changeContent('section7', value)}
            style={styles.editorContainer}
          />
          <Editor
            content={content?.section8}
            setContent={(value) => changeContent('section8', value)}
          />
          <Editor
            content={content?.section9}
            setContent={(value) => changeContent('section9', value)}
            style={styles.editorContainer}
          />
        </Page>
      </Container>
    );
  }
}

export default Template;
